'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'user-tie';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f508';
var svgPathData = 'M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm128-80a128 128 0 1 1 -256 0 128 128 0 1 1 256 0zM193.5 304l61 0c9.7 0 17.5 7.8 17.5 17.5 0 4.2-1.5 8.2-4.2 11.4l-27.4 32 18.4 68.2 56.2-102.5C321 319.5 334.7 315 346.1 320.3 406.2 348.3 448 409.2 448 480l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-43.4-21.6-81.8-54.7-105L277 499.5c-4.2 7.7-12.3 12.5-21 12.5l-64 0c-8.8 0-16.8-4.8-21-12.5L102.7 375C69.6 398.2 48 436.6 48 480l0 8c0 13.3-10.7 24-24 24S0 501.3 0 488l0-8c0-70.8 41.8-131.7 101.9-159.7 11.5-5.3 25.1-.9 31.2 10.2l55.9 102 18.5-67.8-27.2-31.8c-2.7-3.2-4.2-7.2-4.2-11.4 0-9.7 7.8-17.5 17.5-17.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserTie = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;